<template>
  <v-layout :class="['zkm-promo-layout', !isZkm && 'regular-promo-layout']">
    <v-layout
      :column="isZkm && $vuetify.breakpoint.xsOnly"
      :class="[
        !isZkm ? 'card-header-cover' : 'card-header-cover-zkm',
        !isZkm && activeStep === 2 && 'card-header-cover-step-two',
      ]"
    >
      <v-flex>
        <v-layout v-if="isZkm" row wrap>
          <span>predstava</span>
          <v-flex xs12 style="color: #333" class="event-title-header-zkm">
            {{ event.title }}
          </v-flex>
          <span v-if="event.id !== '2247'" id="event-date">
            {{ formatDate(event.from) }}
          </span>

          <v-flex xs12 class="header-description" style="color: #333">
            <span>
              {{ event.organization.publicName }}
            </span>
            <span>,</span>
            <span v-if="event.location && event.location.venue">
              {{ event.location.venue }}
            </span>
          </v-flex>
          <v-flex xs12 class="header-description">
            <span v-if="event.type && !event.topic">
              {{ event.type }}
            </span>
            <span v-if="!event.type && event.topic">
              {{ event.topic }}
            </span>
            <span v-if="event.type && event.topic"> {{ event.type }} / {{ event.topic }} </span>
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          row
          wrap
          :class="['event-data-container', !isZkm && 'event-data-container-regular']"
        >
          <div class="event-data">
            <span
              v-if="isHNBOrganization(event.organization.id)"
              id="event-date"
              class="event-data-item"
            >
              {{ formatDateWithoutTime(event.from) }}
              {{ !isSameDate() ? ` - ${formatDateWithoutTime(event.to)}` : '' }}
            </span>
            <span v-else id="event-date" class="event-data-item">
              {{ formatDate(event.from) }}
            </span>
            <span class="event-data-item-title">
              {{ event.title }}
            </span>
            <span class="event-data-item"> {{ event.organization.publicName }} </span>
          </div>
          <div v-if="!isZkm && event.organization.logo" class="organization-logo-container">
            <img alt="organization logo" class="organization-logo" :src="event.organization.logo" />
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
    <div
      v-if="
        showPromoCodeInputInRegisterContainer(Number(event.id), event.organization.id) &&
        !hideAddPromoCode
      "
      :class="['promo-code-zkm', !isZkm && 'promo-code-container']"
    >
      <add-promo-code
        ref="addPromoCodeRef"
        :promo-code="promoCode"
        :membership="membership"
        :event="event"
        :initial-promo-code="initialPromoCode"
        :color="eventColor"
        :is-zkm="isZkm"
        :order-item-access-code="orderItemAccessCode"
        @applySubscription="applySubscription"
        @removeSubscription="removeSubscription"
        @applyPromoCode="applyPromoCode"
        @applyMembership="applyMembership"
        @removePromoCode="removePromoCode"
        @applyOrderItemAccessCode="applyOrderItemAccessCode"
      />
    </div>
  </v-layout>
</template>
<script>
import moment from 'moment'
import 'moment/locale/hr'
import AddPromoCode from '../tickets/add-promo-code.vue'
import i18next from 'i18next'
import { isHNBOrganization, showPromoCodeInputInRegisterContainer } from '@/utils'

export default {
  name: 'card-header',
  components: {
    AddPromoCode,
  },
  props: {
    event: Object,
    textStyles: {
      type: Object,
      default: () => ({}),
    },
    promoCode: {
      type: Object,
      default: null,
    },
    membership: {
      type: Object,
      default: null,
    },
    initialValues: {
      type: Array,
      default: () => [],
    },
    initialPromoCode: {
      type: String,
      default: null,
    },
    activeStep: {
      type: Number,
      default: 1,
    },
    hideAddPromoCode: {
      type: Boolean,
      default: false,
    },
    orderItemAccessCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      eventColor: this.event.eventTemplateId
        ? '#333'
        : this.getThemeStyle(this.event.coverImagePrimaryColor, null, 'primary'),
    }
  },
  computed: {
    isZkm() {
      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
  },
  watch: {
    '$i18next.language': function () {
      document.getElementById('event-date').innerHTML = this.formatDate(this.event.from)
    },
  },
  methods: {
    isHNBOrganization,
    showPromoCodeInputInRegisterContainer,
    formatDate(timestamp) {
      const lan = i18next.language
      moment.locale(lan)

      return moment(timestamp).format(`D. MMM YYYY ${lan === 'hr' ? '[u]' : '[at]'} HH:mm`)
    },
    applyPromoCode(promoCodeInput) {
      this.$emit('applyPromo', promoCodeInput)
    },
    applyMembership(membershipInput) {
      this.$emit('applyMembershipInParent', membershipInput)
    },
    applySubscription(subscription) {
      this.$emit('applySubscription', subscription)
    },
    removeSubscription() {
      this.$emit('removeSubscription')
    },
    removePromoCode() {
      this.$emit('removeMembership')
      this.$emit('removePromoCode')
      this.$emit('removeOrderItemAccessCode')
    },
    isSameDate() {
      return moment(this.event.to).isSame(moment(this.event.from), 'day')
    },
    formatDateWithoutTime(timestamp) {
      const lan = i18next.language
      moment.locale(lan)

      return moment(timestamp).format('D. MMM YYYY')
    },
    applyOrderItemAccessCode(accessCodeInput) {
      this.$emit('applyOrderItemAccessCode', accessCodeInput)
    },
  },
}
</script>

<style>
.zkm-promo-layout {
  display: flex;
  flex-direction: column;
  border: solid var(--grey-00, #333);
  border-width: 0 0 2px 0;
}

.regular-promo-layout {
  border: none;
  @media screen and (min-width: 993px) {
    margin-right: 1.5rem;
  }
}

.register-button {
  position: absolute;
  transform: translateY(-50%);
  margin: 0;
  top: 0;
  right: 36px;
}

.register-button:hover {
  position: absolute;
}

.header-date-container {
  margin-right: 55px;
}

.card-header-cover {
  display: flex;
  background-color: transparent !important;
  padding: 1rem 1.5rem;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  border: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
}

.card-header-cover-step-two {
  @media screen and (max-width: 992px) {
    display: none;
  }
}

.card-header-cover-zkm {
  padding: 3em 3em 3em 1rem;
  position: relative;
  display: inline-flex !important;
  background-color: transparent !important;
  border: solid var(--grey-00, #333);
  border-width: 2px 0;
  border-radius: 0px;
  margin-bottom: 1.5rem;
}

.header-description {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  color: #979797;
  padding-top: 4px;
  display: block;
}

.event-title-header {
  font-family: Raleway, sans-serif;
  font-weight: bold;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  padding-bottom: 12px;
  color: #333333 !important;
  font-size: 20px;
}

.event-title-header-zkm {
  color: #333333 !important;
  font-size: 20px;
}

@media screen and (max-width: 600px) {
  .event-title-header {
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    word-break: break-word;
  }
}

.event-data {
  display: flex;
  flex-direction: column;
  max-width: 73%;
}

.event-data-item {
  display: block;
  color: #333;
  font-family: Source Sans Pro;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.event-data-item-title {
  display: block;
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Source Sans Pro;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
  word-break: break-word;
  hyphens: auto;
}

.promo-code-container {
  padding-top: 1.5rem;
  border-radius: 0.25rem;
  border: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
  @media screen and (max-width: 800px) and (min-width: 600px) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  @media screen and (max-width: 992px) {
    margin-top: 1.5rem;
  }
}

@media screen and (max-width: 1000px) {
  .card-header-cover {
    border-radius: 0;
    border-left: unset;
    border-right: unset;
  }

  .promo-code-container {
    border: unset;
  }
}

@media screen and (max-width: 800px) {
  .card-header-cover {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    border-radius: 0;
  }
}

.organization-logo-container {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid rgba(151, 151, 151, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.organization-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.event-data-container-regular {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
